import WebFont from 'webfontloader';
import jsCookie from 'js-cookie';

import { getAppWindowTitle } from './reducers/app/title';

const setInitialTitle = store => {
  // Set initial page title from reducer's initial state
  const title = getAppWindowTitle(store.getState());
  window.document.title = title;
};

const loadFontsAsync = (handlers = {}) => new Promise((resolve, reject) => {
  // We load the fonts asynchronously as part of the booting phase if they aren't cached
  // https://css-tricks.com/loading-web-fonts-with-the-web-font-loader/
  // https://www.filamentgroup.com/lab/font-loading.html

  const fontsLoaded = jsCookie.get('fontsLoaded');

  const fontFamilies = {
    google: {
      families: [
        'Roboto:200,400',
        'Open Sans:200,300,700',
        'sans-serif',
      ]
    },
  };

  if (fontsLoaded) {
    document.documentElement.classList.add('wf-active');
    WebFont.load(fontFamilies);
    resolve('active');
  } else {
    WebFont.load({
      ...fontFamilies,
      loading: () => {
        handlers.loading && handlers.loading();
      },
      active: () => {
        jsCookie.set('fontsLoaded', true, 365);
        handlers.active && handlers.active();
        resolve('active');
      },
      inactive: () => {
        handlers.inactive && handlers.inactive();
        reject('Fonts failed to load');
      }
    });
  }
});

const boot = ({ store, fontLoadingHandlers }) => {
  setInitialTitle(store);

  return Promise.all([
    loadFontsAsync(fontLoadingHandlers),
  ]);
};

export default boot;



// WEBPACK FOOTER //
// ./src/boot.js